import { Component, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatStepper, MatStep, MatStepLabel, MatStepContent } from '@angular/material/stepper';
import { ZohoSettingsService } from '../zoho-setup/zoho-settings.service';
import { AccountSetupDialogStore } from './account-setup-dialog.store';
import { FormArray, FormGroup } from '@angular/forms';
import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout';
import { GenericTaxMappingsComponent } from './tax-mappings/generic-tax-mappings.component';
import { GenericAccountMappingComponent } from './account-mappings/generic-account-mappings.component';

@Component({
    selector: 'account-tax-dialog',
    templateUrl: './account-setup-dialog.component.html',
    providers: [ZohoSettingsService, AccountSetupDialogStore],
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, MatStepper, MatStep, MatStepLabel, MatStepContent, GenericAccountMappingComponent, GenericTaxMappingsComponent, MatDialogActions, FlexModule, MatButton, AsyncPipe, TitleCasePipe]
})
export class AccountSetupDialogComponent {
  @ViewChild('stepper', { static: true }) stepper: MatStepper;

  type$ = this.store.integration$;

  accountMappingForm: FormGroup;
  taxMappingForm: FormArray;

  constructor(
    public dialogRef: MatDialogRef<AccountSetupDialogComponent>,
    private store: AccountSetupDialogStore
  ) {}

  setAccountMappingForm(form: FormGroup) {
    setTimeout(() => (this.accountMappingForm = form), 0);
  }

  setTaxMappingForm(form: FormArray) {
    setTimeout(() => (this.taxMappingForm = form), 0);
  }

  save() {
    if (this.stepper.selectedIndex === 0) {
      this.store.saveAccountMappings({
        mappings: this.accountMappingForm.value,
        onSuccess: () => this.stepper.next()
      });
    }
    if (this.stepper.selectedIndex === 1) {
      this.store.saveTaxMappings({
        mappings: this.taxMappingForm.value,
        onSuccess: () => this.dialogRef.close()
      });
    }
  }
}
